import EnrollmentStudentAPI from '@/apis/business/enrollmentStudentAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('EnrollmentStudent', EnrollmentStudentAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    enrollmentStudent: {},
    idContainerCreateTab: null,
    validateFileAttachment: false,
    startLoadMyProfiles: false,
    _config: {
      field: {
        key: 'Id',
        name: 'FullName',
        code: 'EnrollmentStudentCode',
      },
    },
    listStudent: [],
  },
  mutations: {
    ...crudBase.mutations,

    /**
     * @description set giá trị hồ sơ tuyển sinh
     * @param {*} state
     * @param {*} data
     */
    setEnrollmentStudent (state, data) {
      state.enrollmentStudent = data
    },
    /**
     * @description set giá trị cờ load danh sách hồ sơ của tôi
     * @param {*} state
     * @param {*} data
     */
    setStartLoadMyProfiles (state, data) {
      state.startLoadMyProfiles = data
    },

    /**
     * @description set giá trị tab index khi tạo hồ sơ
     * @param {*} state
     * @param {*} data
     */
    setIdContainerCreateTab (state, data) {
      state.idContainerCreateTab = data
    },
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,

    /**
     * Kiểm tra xem đã tồn tại hồ sợ học sinh trong đợt tuyển sinh hay chưa
     * @param {*} context
     * @param {*} model
     * @returns
     */
    async getCountEnrollmentStudentInPeriod (context, model) {
      return await EnrollmentStudentAPI.getCountEnrollmentStudentInPeriod(
        model
      )
    },

    /**
     * @description Lấy danh sách hồ sơ học sinh
     * @author PBac (16/12/2022)
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getStudentProfile (context, payload) {
      const result = await EnrollmentStudentAPI.getStudentProfile(payload)
      return result
    },

    /**
     * @description Tìm kiếm danh sách hồ sơ học sinh
     * @author PBac (16/01/2023)
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async searchStudentProfile (context, payload) {
      const result = await EnrollmentStudentAPI.searchStudentProfile(payload)
      return result
    },

    /**
     * @description Lấy lịch sử tìm kiếm hồ sơ học sinh
     * @author PBac (11/01/2023)
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getStudentProfileHistory (context, payload) {
      // const result = await EnrollmentStudentAPI.getStudentProfileHistory(payload)
      return []
    },

    /**
     * Cập nhật phản hồi phụ huynh cho nhiều đánh giá
     * @param {*} context
     * @param {*} model
     * @returns
     */
    async updateEnrollmentByIds (context, model) {
      return await EnrollmentStudentAPI.updateEnrollmentByIds(model)
    },

    /**
     * Tự động xếp lớp
     * @param {*} param
     */
    arrangeClass: async ({ commit }, model) => {
      return await EnrollmentStudentAPI.arrangeClass(model).then((res) => {
        return res
      })
    },

    /**
     * Chuyển nhóm tuyển sinh
     * @param {*} param0
     * @param {*} model
     * @returns
     */
    switchEnrollmentStudent: async ({ commit }, model) => {
      const result = await EnrollmentStudentAPI.switchEnrollmentStudent(model)
      return result
    },

    /**
     * Hủy kết quả xếp lớp
     * @param {*} param0
     * @param {*} model
     * @returns
     */
    deleteClassArrangementResult: async ({ commit }, model) => {
      const result = await EnrollmentStudentAPI.deleteClassArrangementResult(
        model
      )
      return result
    },
  },
}
